import { TranslatePipe } from '../../filters/translate.pipe';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Config from '../../utils/config.service';
import Session from '../../utils/session.service';
import ChatRestServices from '../../services/chat-rest.service';
import ChatService from '../../services/chat.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	standalone: true,
	selector: 'modal-chat-upload-type-picker',
	templateUrl: './modal-chat-upload-type-picker.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule ]
})
export class ModalChatUploadTypePickerComponent implements OnInit {
	private config: Config = inject(Config);
	private session: Session = inject(Session);
	private chatRestServices: ChatRestServices = inject(ChatRestServices);
	private chatService: ChatService = inject(ChatService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private dialogRef = inject(MatDialogRef<ModalChatUploadTypePickerComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.vm.chat = this.vm.chat || {};
		
		this.initialize();
		
		this.vm.close = this.close;
	}
	
	initialize() {
		this.vm.imageId = 'img-' + Date.now();
		this.vm.videoId = 'vid-' + Date.now();
		this.vm.documentId = 'doc-' + Date.now();
		this.vm.user = this.session.getSession().user;
		
		this.vm.handleMediaUpload = this.handleMediaUpload;
		this.vm.openFileSelect = this.openFileSelect;
	}
	
	openFileSelect(id) {
		document.getElementById(id).click();
	}
	
	onFileSelected(event: Event, type: string): void {
		const input = event.target as HTMLInputElement;
		this.handleMediaUpload(input, type);
	}
	
	handleMediaUpload(input, type) {
		var chatCopy: any = this.angularHelperService.copy(this.vm.chat);
		var medias: any = input.files;
		if (!medias || !medias.length || this.vm.processing) return;
		if (type !== 'video' && type !== 'picture' && type !== 'document') return;
		var media: any = medias[0];
		media.groupId = Date.now();
		var data: any = new FormData();
		data.append('file', media);
		
		this.vm.processing = true;
		this.angularBroadcastHelperService.rootBroadcast(this.config.getBroadcastConfig().Chat.MEDIA_UPLOAD_INIT,
			{ mediaType: type, media: media, chat: chatCopy.id, user: this.vm.user });
		
		var params: any = {
			id: chatCopy && chatCopy.id || chatCopy.privateChatFriend.id,
			fileName: media.name,
		};
		
		var successCallback = (res) => {
			res.groupId = media.groupId;
			if (!chatCopy.id) {
				this.initNewChat(chatCopy.privateChatFriend, this.createMediaData(type, res, chatCopy));
			} else {
				this.angularBroadcastHelperService.rootBroadcast(
					this.config.getBroadcastConfig().Chat.MEDIA_UPLOAD_START,
					this.createMediaData(type, res, chatCopy)
				);
			}
			this.dialogRef.close(this.vm.chat);
		};
		var errorCallback = (err) => {
			this.angularBroadcastHelperService.rootBroadcast(
				this.config.getBroadcastConfig().Chat.MEDIA_UPLOAD_ERROR,
				this.createMediaData(type, media, chatCopy, err)
			);
			this.dialogRef.close(this.vm.chat);
		};
		
		switch (type) {
			case 'video':
				if (chatCopy && chatCopy.id) {
					this.chatRestServices.uploadVideoToChat(params, data, successCallback, errorCallback);
				} else {
					this.chatRestServices.uploadVideoToFriend(params, data, successCallback, errorCallback);
				}
				break;
			case 'picture':
				if (chatCopy && chatCopy.id) {
					this.chatRestServices.uploadImageToChat(params, data, successCallback, errorCallback);
				} else {
					this.chatRestServices.uploadImageToFriend(params, data, successCallback, errorCallback);
				}
				break;
			case 'document':
				if (chatCopy && chatCopy.id) {
					this.chatRestServices.uploadDocumentToChat(params, data, successCallback, errorCallback);
				} else {
					this.chatRestServices.uploadDocumentToFriend(params, data, successCallback, errorCallback);
				}
				break;
		}
	}
	
	initNewChat(user, message) {
		this.chatRestServices.getChatByFriendId({ friendUserId: user.id }, (newChat) => {
			newChat.privateChatFriend = user;
			if (!newChat.privateChatFriend.fullName && user.firstname && user.lastname) {
				newChat.privateChatFriend.fullName = user.firstname + ' ' + user.lastname;
			}
			newChat.lastPost = message;
			newChat.lastSeenPostId = message.id;
			if (this.vm.chat) {
				newChat.conversation = this.vm.chat.conversation;
				newChat.localId = this.vm.chat.localId;
			}
			this.chatService.initNewChat(newChat);
			this.vm.chat = newChat;
			message.chat = newChat;
			this.angularHelperService.createTimer(() => {
				switch (message.postType) {
					case 'VIDEO':
					case 'PICTURE':
						this.angularBroadcastHelperService.rootBroadcast(
							this.config.getBroadcastConfig().Chat.MEDIA_UPLOAD_START, message);
						break;
					default:
						this.angularBroadcastHelperService.rootBroadcast(
							this.config.getBroadcastConfig().Chat.NEW_MESSAGE, [message], newChat.id);
				}
			});
		}, console.error);
	}
	
	createMediaData(type, media, mediaChat, error?) {
		var data: any = media;
		data.chat = mediaChat;
		data.user = this.vm.user;
		data.modified = new Date();
		data.created = new Date();
		data.postType = type.toUpperCase();
		data.contentType = type.toUpperCase();
		if (error) data.error = error;
		
		return data;
	}
	
	close() {
		this.dialogRef.close(this.vm.chat);
	}
	
}